<!--
 * COPYRIGHT Transtron Inc 2023
 *
 * 機能名：会社情報ホーム画面
 *
 * 作成者：2023/06/19 ノア）馬
 * 最終修正者：2023/06/19 ノア）馬
 *
 -->
<template>
  <div class="container">
    <div class="body">
      <tracker-register-header></tracker-register-header>
      <div class="content">
        <router-view></router-view>
      </div>
      <update-password></update-password>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

import TrackerRegisterHeader from '@/components/TrackerRegisterHeader.vue'
import UpdatePassword from '@/components/UpdatePassword.vue'

@Component({
  name: 'COMPANY_HOME',
  components: {
    TrackerRegisterHeader,
    UpdatePassword
  }
})
export default class COMPANY_HOME extends Vue {}
</script>

<style scoped lang="scss">
.container {
  width: 100vw;
  height: 100vh;
  overflow-y: hidden;
  overflow-x: auto;
}

.body {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  min-width: 1650px;
}

.content {
  position: relative;
  width: 100%;
  height: calc(100vh - 48px);
}
</style>
